import { MessageCondition } from '../shared/message-condition/message-condition.model';

PriorityRuleEditionController.$inject = ['$scope', '$mdDialog', 'rule', 'dropdownItems'];
export function PriorityRuleEditionController($scope, $mdDialog, rule, dropdownItems) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.addCondition = addCondition;
  $scope.removeCondition = removeCondition;
    

  init();

  function ok() {
    $mdDialog.hide($scope.rule);
  };

  function cancel() {
    $mdDialog.cancel();
  };

  function addCondition() {
    $scope.rule.conditions.push(new MessageCondition());
  }

  function removeCondition(index) {
    $scope.rule.conditions.splice(index, 1);
  }

  function init() {
    $scope.rule = rule;
    $scope.dropdownItems = dropdownItems;
    $scope.excludedConditionCodes = ['keywords', 'exclude-keywords']; // not implemented for priority rules
  }

}
